export class Base64 {
    // private property

    // public method for encoding
    public static encode(input) {
        // eslint-disable-next-line no-underscore-dangle
        const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output = '';
        let chr1; let chr2; let chr3; let enc1; let enc2; let enc3; let
enc4;
        let i = 0;
        // eslint-disable-next-line no-underscore-dangle
        input = this._utf8_encode(input);
        while (i < input.length) {
            // eslint-disable-next-line no-plusplus
            chr1 = input.charCodeAt(i++);
            // eslint-disable-next-line no-plusplus
            chr2 = input.charCodeAt(i++);
            // eslint-disable-next-line no-plusplus
            chr3 = input.charCodeAt(i++);
            // eslint-disable-next-line no-bitwise
            enc1 = chr1 >> 2;
            // eslint-disable-next-line no-bitwise
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            // eslint-disable-next-line no-bitwise
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            // eslint-disable-next-line no-bitwise
            enc4 = chr3 & 63;
            // eslint-disable-next-line no-restricted-globals
            if (isNaN(chr2)) {
                // eslint-disable-next-line no-multi-assign
                enc3 = enc4 = 64;
            // eslint-disable-next-line no-restricted-globals
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output
                + _keyStr.charAt(enc1) + _keyStr.charAt(enc2)
                + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
    }

    // public method for decoding
    public static decode(input) {
        // eslint-disable-next-line no-underscore-dangle
        const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output = '';
        let chr1; let chr2; let
chr3;
        let enc1; let enc2; let enc3; let
enc4;
        let i = 0;
        // eslint-disable-next-line no-useless-escape
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
        while (i < input.length) {
            // eslint-disable-next-line no-plusplus
            enc1 = _keyStr.indexOf(input.charAt(i++));
            // eslint-disable-next-line no-plusplus
            enc2 = _keyStr.indexOf(input.charAt(i++));
            // eslint-disable-next-line no-plusplus
            enc3 = _keyStr.indexOf(input.charAt(i++));
            // eslint-disable-next-line no-plusplus
            enc4 = _keyStr.indexOf(input.charAt(i++));
            // eslint-disable-next-line no-bitwise
            chr1 = (enc1 << 2) | (enc2 >> 4);
            // eslint-disable-next-line no-bitwise
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            // eslint-disable-next-line no-bitwise
            chr3 = ((enc3 & 3) << 6) | enc4;
            output += String.fromCharCode(chr1);
            // eslint-disable-next-line eqeqeq
            if (enc3 != 64) {
                output += String.fromCharCode(chr2);
            }
            // eslint-disable-next-line eqeqeq
            if (enc4 != 64) {
                output += String.fromCharCode(chr3);
            }
        }
        // eslint-disable-next-line no-underscore-dangle
        output = this._utf8_decode(output);
        return output;
    }

    // private method for UTF-8 encoding
    // eslint-disable-next-line no-underscore-dangle
    static _utf8_encode(string) {
        string = string.replace(/\r\n/g, '\n');
        let utftext = '';
        for (let n = 0; n < string.length; n++) {
            const c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if ((c > 127) && (c < 2048)) {
                // eslint-disable-next-line no-bitwise
                utftext += String.fromCharCode((c >> 6) | 192);
                // eslint-disable-next-line no-bitwise
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                // eslint-disable-next-line no-bitwise
                utftext += String.fromCharCode((c >> 12) | 224);
                // eslint-disable-next-line no-bitwise
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                // eslint-disable-next-line no-bitwise
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    }

    // eslint-disable-next-line no-underscore-dangle
    static _utf8_decode(utftext) {
        let string = '';
        let i = 0;
        let c = 0;
        // const c1 = 0;
        let c2 = 0;
        while (i < utftext.length) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                // eslint-disable-next-line no-plusplus
                i++;
            } else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                // eslint-disable-next-line no-bitwise
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                const c3 = utftext.charCodeAt(i + 2);
                // eslint-disable-next-line no-bitwise
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return string;
    }
}
